/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { XrxCircularProgressComponent } from '../controls/xrx-circular-progess-bar.component';
import { XdaStringsService } from '../../services/xda-strings.service';

@Component({
  selector: 'basic-alert',
  templateUrl: './invite-multip-users.modal.component.html',
  styleUrls: ['./invite-multip-users.modal.component.less'],
  standalone: false,
})
export class BulkInvitaionComponent implements OnInit, AfterViewInit {
  @ViewChild(XrxCircularProgressComponent, { static: false })
  processBar: XrxCircularProgressComponent;

  @Input() title: string;
  @Input() body: string;
  @Input() buttonText = 'SDE_CLOSE';
  @Input() report: InvitaionReport;

  completed = false;
  totalItem: number;
  count = 0;
  successTotal = 0;
  progressInfo: string;

  constructor(
    public activeModal: NgbActiveModal,
    private xdaStringsService: XdaStringsService,
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {}

  public setProgressPercentage(percent: number) {
    this.processBar.setProgress(percent);

    setTimeout(async () => {
      this.count++;
      if (this.totalItem === this.count || this.count > this.totalItem) {
        const totalSuccess =
          this.totalItem -
          this.report.badEmails.length -
          this.report.usersWithOtherSubscription.length -
          this.report.usersWithThisSubscription.length -
          this.report.otherInvalidEmails.length -
          this.report.usersAlreadyInvited.length -
          this.report.usersRejected.length -
          this.report.usersSuspended.length -
          this.report.usersLocked.length -
          this.report.usersDeleted.length;

        this.progressInfo = this.xdaStringsService.strings[
          'SDE_FMTSTR_INVITATIONS_WERE'
        ].replace('{0}', String(totalSuccess));
        this.completed = true;
      } else {
        this.progressInfo = this.xdaStringsService.strings[
          'SDE_PROCESSING_FMTSTR_USER'
        ].replace('{0}', String(this.count));
      }
    }, 10);
  }

  /**
   * return the percentage for each step
   * @param total
   */
  public initProgress(total: number) {
    this.totalItem = total;
    this.completed = false;
    return 100 / total;
  }
}

export interface InvitaionReport {
  badEmails: string[];
  duplicatedEmails: string[];
  usersWithOtherSubscription: string[];
  usersWithThisSubscription: string[];
  usersAlreadyInvited: string[];
  usersSuspended: string[];
  usersRejected: string[];
  usersLocked: string[];
  usersDeleted: string[];
  otherInvalidEmails: string[];
}
